class Passwords {
  validate(password) {
    let error = '';
    const passwordMinLength = 8;
    if (password.length < passwordMinLength) {
      error = 'The password needs to be at least 8 characters long';
    } else if (!/[A-Z]/.test(password)) {
      error = 'The password needs to have at least one uppercase character';
    } else if (!/[a-z]/.test(password)) {
      error = 'The password needs to have at least one lowecase character';
    } else if (!/[0-9]/.test(password)) {
      error = 'The password needs to have at least one number';
    }

    return error;
  }
}

export default Passwords;
